import { all } from "redux-saga/effects";

import { registerJarvisPrimeOnboardingSagas } from "./jarvisPrimeOnboarding/jarvisPrimeOnboardingSaga";
import { registerJarvisPrimeExistingHoldingSagas } from "./jarvisPrimeExistingHolding/jarvisPrimeExistingHoldingSaga";
import { registerprimeHoldingSaga } from "./primeHolding/primeHoldingSagas";
import { registerjarvisPrimeRMSSaga } from "./jarvisPrimeRms/jarvisPrimeRmsSagas";
import { registerjarvisPrimeInvestMoreSagas } from "./jarvisPrimeInvestMore/jarvisPrimeInvestMoreSagas";
import { registerjarvisPrimeDashboardSagas } from "./jarvisPrimeDashboard/jarvisPrimeDashboardSaga";
import { registerJarvisPrimeActionCenterSagas } from "./jarvisPrimeActionCenter/jarivsPrimeActionCenterSagas";
import { registerjarvisPrimeTransactionListSaga } from "./jarvisPrimeTransaction/jarvisPrimeTransactionSaga";

function* registerJarvisPrimeRootSaga() {
  yield all([
    registerJarvisPrimeOnboardingSagas(),
    // registerJarvisPrimeExistingHoldingSagas(),
    registerjarvisPrimeTransactionListSaga(),
    registerprimeHoldingSaga(),
    registerjarvisPrimeInvestMoreSagas(),
    registerjarvisPrimeRMSSaga(),
    registerjarvisPrimeDashboardSagas(),
    registerJarvisPrimeActionCenterSagas(),
  ]);
}

export { registerJarvisPrimeRootSaga };
